import type { LoadMessages } from '@twisto/base/i18n-provider'
import { loadCatalogs } from '@twisto/base/i18n-provider'

export const loadMessages: LoadMessages = (language) =>
  loadCatalogs([
    import(
      /* webpackChunkName: "[request]" */ `../../../public/b2c/locale/${language}/homepage-messages`
    ),
    import(
      /* webpackChunkName: "[request]" */ `../../../public/b2c/locale/${language}/common-messages`
    ),
  ])
